import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import {
  convertIClientDataResponseToIClientData,
  IClientData,
  IClientDataResponse,
} from 'ui-toolkit/orders/interfaces/IClient';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';

export const getAllClientsAsync = async (): Promise<IClientData[]> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IClientDataResponse[]>(`/timber/api/internal/client_companies`)
    .then((r) => r.data.map((t) => convertIClientDataResponseToIClientData(t)))
    .catch(axiosErrorHandler);
